export default {
      id: "dagger-usage",
      viewBox: "0 0 8 8",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#dagger",
      toString: function () {
        return this.url;
      }
    }